import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { passengerHost } from "~/Utils";

interface DocumentDetailsResponse {
  id: string,
  banner_img: string,
  help_txt: string;
  field_help_name_ms: string;
  field_help_name_zh: string;
  field_place_txt_en: string;
  field_place_txt_ms: string;
  field_place_txt_zh: string;
  field_services_txt_en: string;
  field_services_txt_ms: string;
  field_services_txt_zh: string;
  field_support_txt_en: string;
  field_support_txt_ms: string;
  field_support_txt_zh: string;
  field_card_name_en: string;
  field_card_name_ms: string;
  field_card_name_zh: string;
  field_card_redirect_url_en: string;
  field_card_redirect_url_ms: string;
  field_card_redirect_url_zh: string;
  published:boolean;
}

const fetchHelpHeadingDetails = async (id: string): Promise<DocumentDetailsResponse> => {
  const response = await axios.get(`${passengerHost}/api/get-help-banner-images/all-fields`);
  console.log(response.data[0],"tested")
  return response.data[0]; // single object
};

const useHelpHeadingDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError>({
    queryKey: ["HelpHeadingDocumentDetails", id],
    enabled: !!id,
    queryFn: () => fetchHelpHeadingDetails(id),
    refetchOnWindowFocus: false,
    ...options,
  }, queryClient);
};


export { useHelpHeadingDocumentDetails };

